module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('gheader', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('glogo'), _vm._v(" "), _c('grednav', {
    attrs: {
      "type": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row-login carousel slide",
    attrs: {
      "id": "carousel-generic",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "set-position",
    staticStyle: {
      "width": "100%",
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "log-in"
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.welcome))]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn btn-login action",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("立即登录")]), _vm._v(" "), _c('a', {
    staticClass: "form-control btn btn-default btn-apply",
    attrs: {
      "href": "agreement.html?register",
      "target": "_blank"
    }
  }, [_vm._v("供应商注册")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.enterlink
    }
  }, [_vm._v("还没有账号?")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._l((_vm.bannerList), function(item, $index) {
    return _c('div', {
      staticClass: "carousel-inner",
      attrs: {
        "role": "listbox",
        "id": "getOnfocus"
      }
    }, [_vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._m(5, true)])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row-content",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "bid-info pull-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('infotable', {
    staticClass: "table-latest",
    attrs: {
      "tableTitle": _vm.tableTitle[0],
      "tableContent": _vm.tableContent['latest'],
      "which": _vm.tableType[0]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('infotable', {
    staticClass: "table-type",
    attrs: {
      "data-type": "type",
      "tableTitle": _vm.tableTitle[2],
      "tableContent": _vm.tableContent['type'],
      "which": _vm.tableType[2]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('infotable', {
    staticClass: "table-orgName",
    attrs: {
      "data-type": "orgName",
      "tableTitle": _vm.tableTitle[3],
      "tableContent": _vm.tableContent['orgName'],
      "which": _vm.tableType[0]
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bid-notice pull-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "bidding",
      "apiUrl": _vm.noticeUrl[1],
      "num": 2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "company",
      "apiUrl": _vm.noticeUrl[0],
      "ajaxType": 'get',
      "morelink": _vm.moreLink[0]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "lbnotice",
      "apiUrl": _vm.noticeUrl[3],
      "morelink": _vm.moreLink[1]
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('notice', {
    attrs: {
      "type": "cqnotice",
      "apiUrl": _vm.noticeUrl[4],
      "morelink": _vm.moreLink[2]
    }
  })], 1)])])]), _vm._v(" "), _c('regflows'), _vm._v(" "), _c('gfooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "2"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-generic",
      "data-slide-to": "3"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('h5', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/helpCenter.png",
      "alt": ""
    }
  }), _vm._v(" 帮助中心\n          ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "inline-block",
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "static/中裕集采平台供应商操作手册.docx",
      "target": "_blank"
    }
  }, [_vm._v("供应商操作手册")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item active"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg-jsqp2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg-jsqp3"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg-jsqp4"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "carousel-bg carousel-bg-jsqp5"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/template-compiler?{"id":"data-v-15ead6db","hasScoped":false}!./~/.pnpm/vue-loader@12.2.2_n2kyt3n4zhlb2wzyqixseugcou/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/home.vue
// module id = 279
// module chunks = 8